export default __webpack_public_path__ + "static/media/Ma_Silva.4c49b169.png";